import { render, staticRenderFns } from "./weekly-milling-avg.card.vue?vue&type=template&id=f91e9a86&"
import script from "./weekly-milling-avg.card.vue?vue&type=script&lang=js&"
export * from "./weekly-milling-avg.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports